import { type TypographyVariantsOptions } from '@mui/material'
import { grey } from './customColors'

// export function responsiveFontSizes({ sm, md, lg }) {
//   return {
//     '@media (min-width:600px)': {
//       fontSize: sm
//     },
//     '@media (min-width:900px)': {
//       fontSize: md
//     },
//     '@media (min-width:1200px)': {
//       fontSize: lg
//     }
//   }
// }

const FONT_PRIMARY = 'Roboto, sans-serif' // Google Font

export const typography: Partial<TypographyVariantsOptions> = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    color: grey[40],
    fontWeight: 900,
    lineHeight: '50px',
    fontSize: 30
    // ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 })
  },
  h2: {
    fontWeight: 700,
    lineHeight: '30px',
    fontSize: 22
    // ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontWeight: 700,
    lineHeight: '30px',
    fontSize: 20
    // ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontWeight: 700,
    lineHeight: '30px',
    fontSize: 18
    // ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontWeight: 700,
    lineHeight: '30px',
    fontSize: 16
    // ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontWeight: 700,
    lineHeight: '30px',
    fontSize: 14
    // ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 400,
    lineHeight: '24px',
    fontSize: 18
  },
  subtitle2: {
    fontWeight: 400,
    lineHeight: '20px',
    fontSize: 16
  },
  body1: {
    color: '#4D5E80',
    lineHeight: 1.5,
    fontSize: 14
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: 14
  },
  caption: {
    flexGrow: 1,
    fontSize: 14,
    fontWeight: 700
  },
  overline: {
    fontWeight: 900,
    lineHeight: '20px',
    fontSize: 14
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: 14,
    textTransform: 'capitalize'
  },
  allVariants: {
    color: '#7D8FB3',
    fontWeight: 700,
    letterSpacing: 0.01
  }
}

export default typography
